export default "__VITE_ASSET__DuaiOqk0__"